import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ClipBoardBlock } from 'components';

export function Installation() {
  return (
    <Card className="mt-3">
      <Card.Header>Installation issues</Card.Header>
      <Card.Body>
        <ol>
          <li>Open your terminal.</li>
          <li>
            Execute the following command
            <ClipBoardBlock className="w-100 my-1">
              cd /usr/lib/Erply/installer2 && sudo ./installer2_linux
              -service=uninstall && sudo ./installer2_linux -service=install
            </ClipBoardBlock>
          </li>
          <li>
            <Link to="/hardware/installer/installation/Installation">Test</Link>{' '}
            Installer connection again.
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

Installation.title = 'Installation issues';

export function Connection() {
  return (
    <Card className="mt-3">
      <Card.Header>Connection issues</Card.Header>
      <Card.Body>
        <p>
          If the Installer is installed properly (
          <Link to="/hardware/installer/troubleshooting/CheckIfInstalled">
            Check here, if the Installer is running properly
          </Link>
          ) but you are still unable to connect to it, the reason might be that{' '}
          <code>SSLEnable</code> or <code>Port</code> values were changed in
          Installer configuration.
        </p>
        <p>To fix that follow the steps below:</p>
        <ol>
          <li>Open your terminal.</li>
          <li>
            Execute the following command
            <ClipBoardBlock className="w-100 my-1">
              cd /usr/lib/Erply/installer2 && sudo nano config.json
            </ClipBoardBlock>
          </li>
          <li>
            You should see the json object with the Installer configurations in
            the terminal. Make sure that <code>SSLEnabled</code> is set to{' '}
            <code>true</code>. <br />
            If it is not, change the value and save, then restart the service
            with{' '}
            <ClipBoardBlock className="w-100 my-1">
              sudo service installer2 restart
            </ClipBoardBlock>
          </li>
          <li>
            Then go to{' '}
            <Link to="/hardware/installer/installation/Customization">
              Customization section
            </Link>{' '}
            and make sure that <code>Port</code> there is set to the same value.
            <br />
            Once they match, press the{' '}
            <em>Save Installer Configuration Info</em> button.
          </li>
          <li>
            <Link to="/hardware/installer/installation/Installation">Test</Link>{' '}
            Installer connection again.
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

Connection.title = 'Connection issues';

export function CheckIfInstalled() {
  return (
    <Card className="mt-3">
      <Card.Header>
        Check if Installer is installed and running properly
      </Card.Header>
      <Card.Body>
        <p>Follow the steps below:</p>
        <ol>
          <li>Open your terminal.</li>
          <li>
            Execute the following command
            <ClipBoardBlock className="w-100 my-1">
              sudo systemctl status installer2
            </ClipBoardBlock>
            <ul className="m-0 p-0">
              <li>
                Installer is not installed
                <ClipBoardBlock className="w-100" copy={false}>
                  Unit installer2.service could not be found.
                </ClipBoardBlock>
              </li>
              <li>
                Installer is installed and stopped
                <ClipBoardBlock className="w-100" copy={false}>
                  installer2.service - Erply installer service
                  <br />
                  Loaded: loaded
                  <br />
                  Active: inactive
                </ClipBoardBlock>
              </li>
              <li>
                Installer is Installed and running
                <ClipBoardBlock className="w-100" copy={false}>
                  installer2.service - Erply installer service
                  <br />
                  Loaded: loaded
                  <br />
                  Active: active (running)
                </ClipBoardBlock>
              </li>
            </ul>
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

CheckIfInstalled.title = 'Check if Installer is installed properly';


export function InstallationCommands() {
  return (
    <Card className="mt-3">
      <Card.Header>Installer App Commands</Card.Header>
      <Card.Body>
        In order to install, start, stop and uninstall the Installer App,
        execute the following commands in the terminal:
        <ul>
          <li>
            Install
            <ClipBoardBlock className="w-100">
              cd /usr/lib/Erply/installer2 && sudo ./installer2_linux
              -service=install
            </ClipBoardBlock>
          </li>
          <li>
            Start
            <ClipBoardBlock className="w-100">
              cd /usr/lib/Erply/installer2 && sudo ./installer2_linux
              -service=start
            </ClipBoardBlock>
          </li>
          <li>
            Stop
            <ClipBoardBlock className="w-100">
              cd /usr/lib/Erply/installer2 && sudo ./installer2_linux
              -service=stop
            </ClipBoardBlock>
          </li>
          <li>
            Uninstall
            <ClipBoardBlock className="w-100">
              cd /usr/lib/Erply/installer2 && sudo ./installer2_linux
              -service=uninstall
            </ClipBoardBlock>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
}
InstallationCommands.title = 'Installer App Commands';
